import { Link as BaseLink } from 'react-router-dom';

import { styled } from 'stitches';

export const Link = styled(BaseLink, {
  color: '$primary-500',
  textDecoration: 'none',
});
